'use client';

import type { BioContext } from '@ps/functions/bio/bioContext';
import { bioUrl } from '@ps/functions/bio/bioUrls';

/**
 * Open a product's PDP in a NEW browser tab, at the creator-scoped slug URL
 * (`/<urlCode>/product/<slug>`) when a slug is known, else the legacy
 * `/products/<creatorId>/<listingId>`.
 *
 * The single entry point for PDP navigation from owner surfaces (the creator
 * editor, the dashboard products tab, collection detail pages). Those contexts
 * hard-navigate to a new tab rather than the in-app drawer intercept the public
 * bio uses — so we don't mix nav styles across contexts. The caller passes its
 * own `bioContext` (the FACT that shapes the URL, incl. an independent custom
 * domain); `product()` defaults to the non-intercepting form a hard new-tab load
 * needs. See `productHref` for the URL rule.
 */
export function openProductInNewTab(params: {
  bioContext: BioContext;
  listingId: string;
  slug?: string | null;
}): void {
  const { bioContext, listingId, slug } = params;
  const href = bioUrl(bioContext).product({ id: listingId, slug });
  window.open(href, '_blank', 'noopener,noreferrer');
}
